import { render } from "./Comparacion.vue?vue&type=template&id=2f23ba37&scoped=true"
import script from "./Comparacion.vue?vue&type=script&lang=js"
export * from "./Comparacion.vue?vue&type=script&lang=js"

import "./Comparacion.vue?vue&type=style&index=0&id=2f23ba37&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f23ba37"]])

export default __exports__